import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "services/api";
import Breadcrumbs from "components/common/Breadcrumbs";
import ProgrammeSelector from "components/common/ProgrammeSelector";
import PageCard from "components/pages/PageCard"; // Nouvelle carte pour afficher les pages
import styles from "./ProgrammePage.module.css";
import CardSpectacle from "components/common/CardSpectacle";
import archiveStyle from "styles/modules/Archives.module.css";
import Spinner from "components/common/Spinner";
import { Helmet } from "react-helmet";

const SpectaclesPage = () => {
  const [loading, setLoading] = useState(true);
  const [displayCount, setDisplayCount] = useState(8); // Nombre initial de pages affichées
  const [spectacles, setSpectacles] = useState([]);

  useEffect(() => {
    const fetchProgrammeData = async () => {
      try {
        const response = await api.get(`/spectacles/read/spectacle`);
        const spectacles = response.data;
        setSpectacles(spectacles);
      } catch (error) {
        console.error("Erreur lors de la récupération des données des spectacles pour le programme :", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProgrammeData();
  }, []);

  console.log("spectacles", spectacles);

  // Charger plus de pages
  //const loadMore = () => setDisplayCount((prevCount) => prevCount + 6);

  if (loading) return <div className="page-content section-no-padding">
    <section className={`global-section global-section-title ${styles.section}`} style={{ minHeight: '100vh', paddingTop: 200 }}>
      <Spinner />
    </section>
  </div>;
  if (!spectacles) return <div>Programme non trouvé.</div>;

  return (
    <>
      <Helmet>
        <title>Les Spectacles - Pharos</title>
        <meta name="description" content="Découvrez les spectacles à venir sur Pharos. Explorez les événements, les dates et les détails des spectacles." />
        <meta property="og:title" content="Les Spectacles - Pharos" />
        <meta property="og:description" content="Découvrez les spectacles à venir sur Pharos. Explorez les événements, les dates et les détails des spectacles." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="page-content section-no-padding">
        <section className={`global-section global-section-title ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            <div className={archiveStyle.header}>
              <h1 className="h2">Les Spectacles</h1>
              {/* Fil d'Ariane */}
              <Breadcrumbs pageType="isSpectacles" element={{ title: "Les Spectacles" }} />
            </div>
          </div>
        </section>
        <section className={`global-section ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            <ProgrammeSelector activeTab={`spectacles`} />
          </div>
          <div className={`global-container ${styles.content}`}>
            <h2 className="sr-only">Liste des spectacles</h2>
            {/* Liste des pages ou message d'absence */}
            {spectacles && spectacles.length > 0 ? (
              <ul className={`${styles.spectacleList}`}>
                {spectacles.slice(0, displayCount).map((spectacle) => (
                  <CardSpectacle
                    key={spectacle.id}
                    name={spectacle.name}
                    plage_date={spectacle.plage_date}
                    description={spectacle.shortDescription}
                    poster={spectacle.poster}
                    typeShow={spectacle.typeShow}
                    link={`/programme/${spectacle.typeShow.code}/${spectacle.slug}`}
                  />
                ))}
              </ul>
            ) : (
              <p>Aucune page trouvée pour cette catégorie.</p>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default SpectaclesPage;
